import React, { useEffect, useState } from "react";
import { BaseUrl, newBaseUrlLang } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  endInteraction,
  setExternalChatData,
} from "../../../../Redux/Actions/actions";
import {
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Grid,
} from "@mui/material";
import { GitMerge } from "@phosphor-icons/react";
import { toaststyle } from "../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
  };
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Conferanceagentmodel = (props) => {
  const {
    OpenDialog,
    handleClose,
  } = props;
  const [skilldropdown, setSkilldropdown] = useState([]);
  const [languagedropdown, setLanguagedropdown] = useState([]);
  const [skilldropdownid, setSkilldropdownid] = useState("");
  const [languagedropdownid, setLanguagedropdownid] = useState("");
  const [agentbasedonfilter, setAgentbasedonfilter] = useState([]);
  const [agentTransferId, setAgentTransferId] = useState("agent");
  const [showTransferMod, setShowTransferMod] = useState(false);
  const [checkWhichCall, setCheckWhichCall] = useState("");

  const [skillvalid, setskillvalid] = useState(false);
  const [languagevalid, setLanguagevalid] = useState(false);
  const [agentvalid, setAgentvalid] = useState(false);

  const handelAllErrorMessage = () => {
    setskillvalid(false);
    setLanguagevalid(false);
    setAgentvalid(false);
  };

  const handleTransferClose = () => {
    setAgentTransferId("agent");
    setShowTransferMod(false);
  };

  const transferAgent = (val) => {
    setCheckWhichCall(val);
    setShowTransferMod(true);
  };

  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        //
        setSkilldropdown(res.data.dataList);
      })
      .catch((error) => {
        // errorHandel(error, "/skills/list")
      });
  };

  const sortedItemsSkillset = skilldropdown.slice().sort();
  sortedItemsSkillset.sort((a, b) => a.skillName.localeCompare(b.skillName));

  const languageDropdownList = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/languages/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),

          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLanguagedropdown(res.data.dataList);
      })
      .catch((error) => { });
  };

  const sortedItemsLanguage = languagedropdown.slice().sort();
  sortedItemsLanguage.sort((a, b) =>
    a.languageDesc.localeCompare(b.languageDesc)
  );

  const userBasedonLanguageSkillset = (skillId, languageid) => {
    let userId = JSON.parse(localStorage.getItem("tokenAgent"));
    // alert('id',id)
    const access_token = localStorage.getItem("access_token");
    let data = {
      language_id: languageid ? languageid : languagedropdownid,
      skillset_id: skillId ? skillId : skilldropdownid,
      agent_id: userId.id,
    };
    axios
      .post(BaseUrl + "/users/listUserBySkillsetIdLanguageId", data, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == true) {
          setAgentbasedonfilter(res.data.data);
        }
      })
      .catch((error) => { });
  };

  const sortedItemsAgentList = agentbasedonfilter.slice().sort();
  sortedItemsAgentList.sort((a, b) => a.username.localeCompare(b.username));

  const ConfrenceToAgent = async () => {
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client"));
      let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));
      const selectedOption =
        agentTransferId.options[agentTransferId.selectedIndex];
      const selectedName = selectedOption.text;
      const selectedId = selectedOption.value;

      if (selectedName === "agent") {
        alert("select agent");
        return false;
      }

      let message_to_pass = `Conference with ${old_agent_id.username} and ${selectedName}`;

      await axios
        .post(
          BaseUrl + "/users/conferenceAgent",
          {
            sessionId: selectedChat.chat_session_id,
            agentId: selectedId,
            oldAgentId: old_agent_id.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status) {
            handleClose();
            await axios.post(
              BaseUrl + "/message/addMessage",
              {
                from: old_agent_id.id,
                to: selectedChat.id,
                message: message_to_pass,
                senderName: old_agent_id.username,
                receiverName: selectedChat.username,
                messageFrom: "fromAgent",
                userType: selectedChat.chat_type,
                session: selectedChat.chat_session_id,
                msg_sent_type: "NOTIFICATIONS",
              },
              {
                headers: {
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            );

            toast.success("Conferenced to Agent success", toaststyle);
            props.endInteraction();
            props.setExternalChatData("");
            localStorage.removeItem("client");
          } else {
            props.setExternalChatData("");
            handleClose();
            toast.warn(data.data.message, toaststyle);
          }
        })
        .catch((err) => {
          console.log("ConfrenceToAgent", err);
        });
    } catch (error) {
      console.log("ConfrenceToAgent", error);
    }
  };

  useEffect(() => {
    languageDropdownList();
    skillsetDropdown();
  }, []);

  return (
    <>
      <Dialog
        open={OpenDialog}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600, boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
      >
          Conference to agent
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack className="mt-3"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                <label for="formFile" className="form-label fs-13">Skillset</label>
                <select
                  className={`form-select fs-13 form-select-sm ${skillvalid}`}
                  aria-label="Default select example"
                  onChange={(e) => {
                    setSkilldropdownid(e.target.value);
                    userBasedonLanguageSkillset(e.target.value, "");
                    setskillvalid(false);
                  }}
                >
                  <option selected disabled value="">
                    Select Skillset
                  </option>
                  {sortedItemsSkillset.length > 0 ? (
                    sortedItemsSkillset.map((item, index) => {
                      return (
                        <option id={index} value={item.skillId}>
                          {item.skillName}
                        </option>
                      );
                    })
                  ) : (
                    <option>No Skillset</option>
                  )}
                </select>
                </Grid>
                <Grid item xs={6}>
                <label for="formFile" className="form-label fs-13">Language</label>
                <select
                  className={`form-select fs-13 form-select-sm ${languagevalid}`}
                  aria-label="Default select example"
                  onChange={(e) => {
                    setLanguagedropdownid(e.target.value);
                    userBasedonLanguageSkillset("", e.target.value);
                    setLanguagevalid(false);
                  }}
                >
                  <option selected disabled value="">
                    Select language
                  </option>
                  {sortedItemsLanguage.length > 0 ? (
                    sortedItemsLanguage.map((item, index) => {
                      return (
                        <option id={index} value={item.languageId}>
                          {item.languageDesc}
                        </option>
                      );
                    })
                  ) : (
                    <option>No Language</option>
                  )}
                </select>
                </Grid>
                <Grid item xs={12}>
                <label for="formFile" className="form-label fs-13">Agent</label>
                <select
                className={`form-select fs-13 form-select-sm ${agentvalid ? "is-invalid" : ""
                  }`}
                name="availableAgent"
                onChange={(e) => {
                  setAgentTransferId(e.target);
                  setAgentvalid(false);
                }}
              >
                <option value="" selected disabled>
                Select available agent
                </option>

                {sortedItemsAgentList.map((item, index) => {
                  return (
                    <option id={index} value={item.id}>
                      {item.username}
                    </option>
                  );
                })}
              </select>
              {agentvalid && (
                <div className="invalid-feedback">Please select an Agent</div>
              )}
                </Grid>
              </Grid>
              
            
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
          <Button
            onClick={() => {
              if (agentTransferId === "agent") {
                setAgentvalid(true);
              }

              ConfrenceToAgent();
            }}
            sx={{ textTransform: "capitalize !important" }}
            variant="contained"
            size="small"
            disableElevation
          >
            {checkWhichCall}
            Conference
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setExternalChatData,
})(Conferanceagentmodel);
